import {TYPE_NAMES} from '../../shared/models/api/eCertificatesResponsePayload';

export const isAmountChangeNegative = (typeName: TYPE_NAMES) => {
  return [TYPE_NAMES['Покупка'], TYPE_NAMES['Возврат в бюджет'], TYPE_NAMES['Корректировка отрицательная']].includes(
    typeName,
  );
};
